import PropTypes from 'prop-types';
import React from 'react';
import app from '@frontastic/catwalk/src/js/app/app';
import { Link } from '../../atoms/link/Link';
import { FORM_TYPE } from '../../molecules/account/accountDropdown/AccountDropdown';
import { Heading } from '../../typography/heading/Heading';
import styles from './Footer.module.scss';
import { useOpenSignForm } from '../../../utils/useOpenSignForm';

export const FooterColumn = ({
  title = null,
  links = [],
  loggedIn,
  currentLocale
}) => {
  const { signFormOpen } = useOpenSignForm();

  return (
    <div className={styles.footerColumn}>
      {title ? (
        <Heading
          as="p"
          textTransform="uppercase"
          weight="light"
          customClasses={{
            common_p: styles.common_p,
          }}
        >
          {title}
        </Heading>
      ) : null}
      <ul>
        {links &&
          Array.from(links).map((link, index) => {
            if (currentLocale === link?.navLocale || link.navLocale === 'all') {
              return (
                <li key={index}>
                  {link.reference?.target === '/registration' ? (
                    <span
                      onClick={() =>
                        loggedIn
                          ? app
                              .getRouter()
                              .push(
                                'Frontastic.Frontend.Master.Account.profile',
                              )
                          : signFormOpen(FORM_TYPE.REGISTER)
                      }
                      className={styles.footerLink}
                    >
                      {link.label}
                    </span>
                  ) : (
                    <Link link={link} className={styles.footerLink}>
                      {link.label}
                    </Link>
                  )}
                </li>
              );
            }
            return null;
          })}
      </ul>
    </div>
  );
};

FooterColumn.propTypes = {
  title: PropTypes.string,
  links: PropTypes.array,
  loggedIn: PropTypes.bool,
};
